import {
    IQuestionsGroupContainerProps,
    QuestionsGroupContainer,
} from "app/containers/PipelineSection/QuestionGroupContainer"
import { Profile } from "app/redux/Profile/model"
import { getBrandHelpers, getBrandInfo } from "config"
import { ConfigNames } from "config/interfaces"
import * as _ from "lodash"
import * as React from "react"
import { Button } from "react-bootstrap"

//From webpack
declare const CONFIG_NAME: ConfigNames

interface IPensionIntroContainerState {
    hasEnoughInfoForPension: boolean
    profile: Profile
}

class PensionIntroContainer extends QuestionsGroupContainer<
    IQuestionsGroupContainerProps,
    IPensionIntroContainerState
> {
    state: IPensionIntroContainerState = {
        hasEnoughInfoForPension: false,
        profile: undefined,
    }

    componentWillMount() {
        this.onAppStateUpdate((appState) => {
            const profile = appState.Profile.get("info")
            const member = profile.getHeadOfHousehold()
            const hasEnoughInfoForPension = !!member.firstName

            this.setState({ profile, hasEnoughInfoForPension })
        })
    }

    makeLink(linkText: string, url: string) {
        const link = "<a href=" + url + ' target="_blank">here</a>'
        return { __html: linkText.replace("{link}", link) }
    }

    renderPensionInfoNotes() {
        const info = getBrandHelpers().getPensionInfoNotes(this.state.profile)
        if (0 === info.length) {
            return null
        }
        const l697Styles = {
            marginLeft: "5rem",
            marginRight: "15rem",
            color: "red",
            fontWeight: "bold" as "bold",
        }
        return (
            <section>
                <h5 className="lead">
                    The following plan-related documents may be helpful as you
                    consider the pension benefits available to you:
                </h5>
                {_.map(info, (e, key) => {
                    if (e.isEntireLinkText) {
                        return (
                            <p
                                key={key.toString()}
                                dangerouslySetInnerHTML={this.makeLink(
                                    e.linkText,
                                    e.url
                                )}
                            ></p>
                        )
                    } else {
                        return (
                            <p key={key.toString()}>
                                <a href={e.url} target="_blank">
                                    <i className="fa fa-download fa-fw" />{" "}
                                    Download
                                </a>
                                &nbsp;{e.linkText}
                            </p>
                        )
                    }
                })}
                <br />
            </section>
        )
    }

    render() {
        return (
            <section>
                <h1>Calculate Pension</h1>
                {getBrandInfo().markup.pension.introduction.intro1}
                {this.renderPensionInfoNotes()}
                {this.state.hasEnoughInfoForPension ? (
                    <Button type="submit" bsStyle="primary" bsSize="lg">
                        Get Started
                    </Button>
                ) : (
                    <section>
                        <h5 className="lead">
                            To get started with this section, we'll need more
                            information in your profile.
                        </h5>
                        <Button
                            bsStyle="primary"
                            bsSize="lg"
                            onClick={() =>
                                this.relocate("#/profile", {
                                    redirectTo: "#/pension/1",
                                    btnText: "Get Started on Pension",
                                })
                            }
                        >
                            Update Profile
                        </Button>
                    </section>
                )}
            </section>
        )
    }
}

const PensionIntro = () => (
    <PensionIntroContainer header="Pension Intro" icon="" />
)

export { PensionIntro }



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/Pension/Introduction/index.tsx